// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.VideoConfiguration in videoConfig/videoconfig.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Float
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import okio.ByteString

/**
 * Video configuration message. Represents video configuration.
 *
 * @property height Height of the video frame in pixels
 * @property width Width of the video frame in pixels
 * @property frame_rotation Rotation of the video frame
 * @property target_brightness Target brightness value
 * @property max_exposure_time_us Maximum exposure time in microseconds
 * @property min_exposure_time_us Minimum exposure time in microseconds
 * @property max_gain Maximum gain value
 * @property min_gain Minimum gain value
 * @property zoom zoom and focus parameters
 */
public class VideoConfiguration(
  @field:WireField(
    tag = 1,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 0,
  )
  public val height: Int = 0,
  @field:WireField(
    tag = 2,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 1,
  )
  public val width: Int = 0,
  @field:WireField(
    tag = 3,
    adapter = "vreo.volt.protocol.FrameRotation#ADAPTER",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "frameRotation",
    schemaIndex = 2,
  )
  public val frame_rotation: FrameRotation = FrameRotation.ROTATE_0,
  @field:WireField(
    tag = 4,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "targetBrightness",
    schemaIndex = 3,
  )
  public val target_brightness: Int = 0,
  @field:WireField(
    tag = 5,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "maxExposureTimeUs",
    schemaIndex = 4,
  )
  public val max_exposure_time_us: Int = 0,
  @field:WireField(
    tag = 6,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "minExposureTimeUs",
    schemaIndex = 5,
  )
  public val min_exposure_time_us: Int = 0,
  @field:WireField(
    tag = 7,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "maxGain",
    schemaIndex = 6,
  )
  public val max_gain: Float = 0f,
  @field:WireField(
    tag = 8,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "minGain",
    schemaIndex = 7,
  )
  public val min_gain: Float = 0f,
  @field:WireField(
    tag = 9,
    adapter = "vreo.volt.protocol.ZoomAndFocus#ADAPTER",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "zoomConfig",
    schemaIndex = 8,
  )
  public val zoom_config: ZoomAndFocus? = null,
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<VideoConfiguration, Nothing>(ADAPTER, unknownFields) {
  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is VideoConfiguration) return false
    if (unknownFields != other.unknownFields) return false
    if (height != other.height) return false
    if (width != other.width) return false
    if (frame_rotation != other.frame_rotation) return false
    if (target_brightness != other.target_brightness) return false
    if (max_exposure_time_us != other.max_exposure_time_us) return false
    if (min_exposure_time_us != other.min_exposure_time_us) return false
    if (max_gain != other.max_gain) return false
    if (min_gain != other.min_gain) return false
    if (zoom_config != other.zoom_config) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + height.hashCode()
      result = result * 37 + width.hashCode()
      result = result * 37 + frame_rotation.hashCode()
      result = result * 37 + target_brightness.hashCode()
      result = result * 37 + max_exposure_time_us.hashCode()
      result = result * 37 + min_exposure_time_us.hashCode()
      result = result * 37 + max_gain.hashCode()
      result = result * 37 + min_gain.hashCode()
      result = result * 37 + (zoom_config?.hashCode() ?: 0)
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    result += """height=$height"""
    result += """width=$width"""
    result += """frame_rotation=$frame_rotation"""
    result += """target_brightness=$target_brightness"""
    result += """max_exposure_time_us=$max_exposure_time_us"""
    result += """min_exposure_time_us=$min_exposure_time_us"""
    result += """max_gain=$max_gain"""
    result += """min_gain=$min_gain"""
    if (zoom_config != null) result += """zoom_config=$zoom_config"""
    return result.joinToString(prefix = "VideoConfiguration{", separator = ", ", postfix = "}")
  }

  public fun copy(
    height: Int = this.height,
    width: Int = this.width,
    frame_rotation: FrameRotation = this.frame_rotation,
    target_brightness: Int = this.target_brightness,
    max_exposure_time_us: Int = this.max_exposure_time_us,
    min_exposure_time_us: Int = this.min_exposure_time_us,
    max_gain: Float = this.max_gain,
    min_gain: Float = this.min_gain,
    zoom_config: ZoomAndFocus? = this.zoom_config,
    unknownFields: ByteString = this.unknownFields,
  ): VideoConfiguration = VideoConfiguration(height, width, frame_rotation, target_brightness, max_exposure_time_us, min_exposure_time_us, max_gain, min_gain, zoom_config, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<VideoConfiguration> =
        object : ProtoAdapter<VideoConfiguration>(
      FieldEncoding.LENGTH_DELIMITED, 
      VideoConfiguration::class, 
      "type.googleapis.com/vreo.volt.protocol.VideoConfiguration", 
      PROTO_3, 
      null, 
      "videoConfig/videoconfig.proto"
    ) {
      override fun encodedSize(`value`: VideoConfiguration): Int {
        var size = value.unknownFields.size
        if (value.height != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(1, value.height)
        }
        if (value.width != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(2, value.width)
        }
        if (value.frame_rotation != vreo.volt.protocol.FrameRotation.ROTATE_0) {
          size += FrameRotation.ADAPTER.encodedSizeWithTag(3, value.frame_rotation)
        }
        if (value.target_brightness != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(4, value.target_brightness)
        }
        if (value.max_exposure_time_us != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(5, value.max_exposure_time_us)
        }
        if (value.min_exposure_time_us != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(6, value.min_exposure_time_us)
        }
        if (!value.max_gain.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(7, value.max_gain)
        }
        if (!value.min_gain.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(8, value.min_gain)
        }
        if (value.zoom_config != null) {
          size += ZoomAndFocus.ADAPTER.encodedSizeWithTag(9, value.zoom_config)
        }
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: VideoConfiguration) {
        if (value.height != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 1, value.height)
        }
        if (value.width != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 2, value.width)
        }
        if (value.frame_rotation != vreo.volt.protocol.FrameRotation.ROTATE_0) {
          FrameRotation.ADAPTER.encodeWithTag(writer, 3, value.frame_rotation)
        }
        if (value.target_brightness != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 4, value.target_brightness)
        }
        if (value.max_exposure_time_us != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 5, value.max_exposure_time_us)
        }
        if (value.min_exposure_time_us != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 6, value.min_exposure_time_us)
        }
        if (!value.max_gain.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 7, value.max_gain)
        }
        if (!value.min_gain.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 8, value.min_gain)
        }
        if (value.zoom_config != null) {
          ZoomAndFocus.ADAPTER.encodeWithTag(writer, 9, value.zoom_config)
        }
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: VideoConfiguration) {
        writer.writeBytes(value.unknownFields)
        if (value.zoom_config != null) {
          ZoomAndFocus.ADAPTER.encodeWithTag(writer, 9, value.zoom_config)
        }
        if (!value.min_gain.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 8, value.min_gain)
        }
        if (!value.max_gain.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 7, value.max_gain)
        }
        if (value.min_exposure_time_us != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 6, value.min_exposure_time_us)
        }
        if (value.max_exposure_time_us != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 5, value.max_exposure_time_us)
        }
        if (value.target_brightness != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 4, value.target_brightness)
        }
        if (value.frame_rotation != vreo.volt.protocol.FrameRotation.ROTATE_0) {
          FrameRotation.ADAPTER.encodeWithTag(writer, 3, value.frame_rotation)
        }
        if (value.width != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 2, value.width)
        }
        if (value.height != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 1, value.height)
        }
      }

      override fun decode(reader: ProtoReader): VideoConfiguration {
        var height: Int = 0
        var width: Int = 0
        var frame_rotation: FrameRotation = FrameRotation.ROTATE_0
        var target_brightness: Int = 0
        var max_exposure_time_us: Int = 0
        var min_exposure_time_us: Int = 0
        var max_gain: Float = 0f
        var min_gain: Float = 0f
        var zoom_config: ZoomAndFocus? = null
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> height = ProtoAdapter.INT32.decode(reader)
            2 -> width = ProtoAdapter.INT32.decode(reader)
            3 -> try {
              frame_rotation = FrameRotation.ADAPTER.decode(reader)
            } catch (e: ProtoAdapter.EnumConstantNotFoundException) {
              reader.addUnknownField(tag, FieldEncoding.VARINT, e.value.toLong())
            }
            4 -> target_brightness = ProtoAdapter.INT32.decode(reader)
            5 -> max_exposure_time_us = ProtoAdapter.INT32.decode(reader)
            6 -> min_exposure_time_us = ProtoAdapter.INT32.decode(reader)
            7 -> max_gain = ProtoAdapter.FLOAT.decode(reader)
            8 -> min_gain = ProtoAdapter.FLOAT.decode(reader)
            9 -> zoom_config = ZoomAndFocus.ADAPTER.decode(reader)
            else -> reader.readUnknownField(tag)
          }
        }
        return VideoConfiguration(
          height = height,
          width = width,
          frame_rotation = frame_rotation,
          target_brightness = target_brightness,
          max_exposure_time_us = max_exposure_time_us,
          min_exposure_time_us = min_exposure_time_us,
          max_gain = max_gain,
          min_gain = min_gain,
          zoom_config = zoom_config,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: VideoConfiguration): VideoConfiguration = value.copy(
        zoom_config = value.zoom_config?.let(ZoomAndFocus.ADAPTER::redact),
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
